import React from "react";
import { Col, Button, Alert } from "antd";
import "./welcomeRight.css";
import Header from "../header/Header";
import ArticleBlock from "../articleblocl/ArticleBlock";

const welcomeRight = ({ user, logout, login }) => {
  const info = [
    {
      title:
        "The carbonic anhydrase IX inhibitor SLC-0111 sensitises cancer cells to conventional chemotherapy.",
      authorString:
        "Andreucci E, Ruzzolini J, Peppicelli S, Bianchini F, Laurenzana A, Carta F, Supuran CT, Calorini L.",
      firstPublicationDate: "2019-12-01",
      doi: "10.1080/14756366.2018.1532419",
      id: "30362384",
    },
    {
      title:
        "N-Acetylcysteine in depressive symptoms and functionality: a systematic review and meta-analysis.",
      authorString:
        "Porcu M, Urbano MR, Verri WA, Barbosa DS, Baracat M, Vargas HO, Machado RCBR, Pescim RR, Nunes SOV.",
      firstPublicationDate: "2018-03-13",
      doi: "10.1016/j.psychres.2018.02.056",
      id: "29605103",
    },
    {
      title: "Machine Learning and Data Analytics in Pervasive Health.",
      authorString: " Oliver N, Mayora O, Marschollek M.",
      firstPublicationDate: "2018-09-01",
      doi: "10.1055/s-0038-1673243",
      id: "30677782",
    },
    {
      title:
        "The DeStress for Success Program: effects of a stress education program on cortisol levels and depressive symptomatology in adolescents making the transition to high school.",
      authorString:
        "Lupien SJ, Ouellet-Morin I, Trépanier L, Juster RP, Marin MF, Francois N, Sindi S, Wan N, Findlay H, Durand N, Cooper L, Schramek T, Andrews J, Corbo V, Dedovic K, Lai B, Plusquellec P.",
      firstPublicationDate: "2013-02-09",
      doi: "10.1016/j.psychres.2018.02.056",
      id: "23403176",
    },
  ];
  return (
    <Col className="col" value={100} span={12}>
      <h2 className="head-3" id="fq">
        <a href="#fq"> #</a>Что это за приложение?
      </h2>
      <p className="item-list">
        Приложение осуществляет поиск медицинских статей в базе данных
        <a style={{ marginLeft: 3 }} href="https://www.embl.org/">
          EMBL
        </a>
        . EMBL - Европейская молекулярно-биологическая лаборатория (англ.
        European Molecular Biology Laboratory, EMBL) — фундаментальный
        научно-исследовательский институт, который финансируется из средств,
        выделяемых двадцатью странами-участниками и страной-партнером
        Австралией.
      </p>
      <h2 className="head-3" id="sq">
        <a href="#fq"> #</a>Как им пользоваться?
      </h2>
      <p className="item-list">
        Что бы пользоваться сервисом нужно обязательно авторизоваться.
      </p>
      <h2 className="head-3" id="one">
        <a href="#two"> #</a>Войдите в приложение с помощью Google
      </h2>
      <Button
        className="welcome-login"
        icon="google"
        type="primary"
        onClick={login}
      >
        Login
      </Button>
      <p className="item-list">
        Авторизовавшись, вы сможете добавлять статьи в избранное.
      </p>
      <h2 className="head-3" id="two">
        <a href="#two"> #</a>Напишите запрос в поисковой строке. Поиск
        осуществляется:
      </h2>
      <div className="list">
        <li className="item-list" id="keys">
          <a href="#keys"> #</a>По ключевым словам, например
          <span className="mark">"cancer"</span>.
        </li>
        <div className="Header">
          <Header
            example={"cancer"}
            user={user}
            logout={logout}
            login={login}
            style={{ position: "absolute", width: "100%" }}
          />
          <ArticleBlock example={true} data={info[0]} key={1} />
        </div>
        <li className="item-list" id="fullName">
          <a href="#two"> #</a>Полным названиям исследований, например
          <span className="mark">
            "N-Acetylcysteine in depressive symptoms"
          </span>
          .
        </li>

        <div className="Header">
          <Header
            example={"N-Acetylcysteine in depressive symptoms"}
            user={user}
            logout={logout}
            login={login}
            style={{ position: "absolute", width: "100%" }}
          />
          <ArticleBlock example={true} data={info[1]} key={2} />
        </div>

        <li className="item-list" id="DOI">
          <a href="#two"> #</a>По <span className="mark">DOI</span>, например
          <span className="mark">10.1055/s-0038-1673243</span>.
          <Alert
            className="item-list"
            type="info"
            showIcon
            message="DOI или идентификатор цифрового объекта – это присвоенный номер
                электронному документу в глобальной сети Интернет, благодаря
                которому существенно упрощается поиск и использование
                материалов. Проще говоря, это ссылка на конкретный объект.
                Зачастую данная технология используется в научных кругах.
                Основной особенностью является то, что объекты с идентификатором
                может удалить только издатель, то есть организация, разместившая
                его."
          />
        </li>

        <div className="Header">
          <Header
            example={"10.1055/s-0038-1673243"}
            user={user}
            logout={logout}
            login={login}
            style={{ position: "absolute", width: "100%" }}
          />
          <ArticleBlock example={true} data={info[2]} key={3} />
        </div>

        <li className="item-list" id="id">
          <a href="#two"> #</a>По <span className="mark">PMID/PMCID</span>,
          например
          <span className="mark">23403176</span>.
          <Alert
            className="item-list"
            type="info"
            showIcon
            message="PMID (от англ. PubMed Identifier, PubMed ID) — уникальный
                идентификационный номер, присваиваемый каждой публикации,
                описание, аннотация или полный текст которой хранятся в базе
                данных PubMed."
          />
        </li>
        <div className="Header">
          <Header
            example={"23403176"}
            user={user}
            logout={logout}
            login={login}
            style={{ position: "absolute", width: "100%" }}
          />
          <ArticleBlock example={true} data={info[3]} key={4} />
        </div>
      </div>
    </Col>
  );
};

export default welcomeRight;
